import NewsChangeCreate from './NewsChangeCreate'

export default NewsChangeCreate
